/* globals alert, console, require, window */
/* jshint esversion: 6 */
/* jshint globalstrict: true */
'use strict';

const started = (function () {
        console.time('start:');
        return true;
    })(),
    async = require('async'),
    inert = require('inert-polyfill'),
    Backbone = require('backbone'),
    BackboneRadio = require('backbone.radio'),
    bootstrap = require('./node_modules/bootstrap/dist/js/bootstrap.bundle.min.js'),
    jQuery = require('jquery'),
    datepicker = require('./node_modules/bootstrap-datepicker/dist/js/bootstrap-datepicker.js'),
    detectSwipe = require('detect_swipe'),
    Modal = require('bootstrap/js/dist/modal'),
    Marionette = require('backbone.marionette'),
    //
    // templates needs to be loaded before handlebars
    // and templates and handlebars have to go before any views that use the templates
    // (albeit just the one time here...)
    templates = require('./builds/templates'),
    handlebars = require('./utilities/handlebars'),
    //
    Container = require('./views/container'),
    Application = Marionette.Application.extend({
        region: 'div[data-name=application]',
        onStart: function () {
            this.showView(new Container());
            Backbone.history.start();
        }
    }),
    jQueryAux = require('./utilities/jqueryAux'),
    configuration = require('./utilities/configuration'),
    enumerations = require('./utilities/enumerations'),
    iframeResizer = require('./libs/iframe.resizer.iframe'),  // resizes the iframe we live in to match content size
    jsonp = require('./utilities/jsonp'),
    outChannel = BackboneRadio.channel('vaultInterface:out'),
    inChannel = BackboneRadio.channel('vaultInterface:in'),
    tips = require('./utilities/tips'),
    user = require('./models/user'),
    vaultInterface = require('./utilities/vaultInterface'),   // broadcasts messages to and from iFrame host on the Backbone radio
    application = new Application(),
    EOL = true;

window._jQuery_ = jQuery;

window.onerror = function (message, source, lineNumber, columnNumber, error) {
    const o = {
            message: message,
            source: source,
            lineNumber: lineNumber,
            columnNumber: columnNumber,
            error: error
        },
        msg = JSON.stringify(o, null, 4);
    if (configuration.onerrorAlerts && msg.toLowerCase().indexOf('resizeobserver') === -1) {
        alert(JSON.stringify(o, null, 4));
    }
    return false;
};

// jQuery(window).keydown(function (event) {
//     if (event.keyCode === 13) {
//         event.preventDefault();
//         return false;
//     }
// });
// jQuery.ajaxSetup({cache: true}); // @acavan! do we need cache buster?

// ie polyfills
if (!Number.MAX_SAFE_INTEGER) {
    Number.MAX_SAFE_INTEGER = 9007199254740991;
    Number.MIN_SAFE_INTEGER = -9007199254740991;
}

async.parallel([
    function (callback) {
        // console.log('@enumerations');
        enumerations.initialize(callback);
    },
    function (callback) {
        // console.log('@handlebars');
        handlebars.initialize(callback);
    },
    function (callback) {
        // console.log('@tips');
        tips.initialize(callback);
    },
    function (callback) {
        const googleApiUrl = 'https://maps.googleapis.com/maps/api/js?callback=_googleMapsJsonpCallback_&libraries=places&key=' + configuration.googleApiKey;
        jsonp(googleApiUrl, '_googleMapsJsonpCallback_', function () {
            callback(null);
        });
    },
    function (callback) {
        if (configuration.embedded) {
            outChannel.trigger('requestHostContext');
            inChannel.once('setHostContext', function (context) {
                callback(null);
            });
        } else {
            callback(null);
        }
    }
], function () {
    application.start();
    outChannel.trigger('vaultDoneLoading'); // notify our iframe
    outChannel.trigger('requestHostContext');
});
